export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:14001/api";
export const API_URL_V2 = process.env.REACT_APP_API_URL_V2 || "http://localhost:14003/api/v2";